// routes/_authenticated/companies/$cnpj/route.tsx — pass-through layout so
// the company page can have child routes (e.g. /companies/:cnpj/itr-evolution).
// Renders only the child route's element; no chrome of its own.
//
// It also accepts a ticker in place of the CNPJ (`/companies/VALE3`) and
// redirects to the canonical CNPJ path, so every child page inherits the
// alias without its own lookup.
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { cnpjForTicker, TICKER_RE } from "@/features/companies/api";

export const Route = createFileRoute("/_authenticated/companies/$cnpj")({
  // An unknown ticker falls through to the child route, which renders its own
  // empty state for a CNPJ the lake doesn't have.
  beforeLoad: async ({ params, location }) => {
    const raw = decodeURIComponent(params.cnpj);
    if (!TICKER_RE.test(raw)) return;
    const cnpj = await cnpjForTicker(raw);
    if (!cnpj) return;
    // Swap only the CNPJ segment so `/companies/VALE3/itr-evolution?year=2025`
    // keeps its child path and search params.
    throw redirect({
      href: `${location.pathname.replace(/\/companies\/[^/]+/, `/companies/${cnpj}`)}${location.searchStr}`,
      replace: true,
    });
  },
  component: CompanyLayoutRoute,
});

function CompanyLayoutRoute() {
  return <Outlet />;
}
